/**
 * <ob-compare>: before/after slider.
 * Drag anywhere on the image (mouse or touch) to move the split; vertical swipes still scroll the page.
 * The hidden range input carries keyboard control and the accessible value.
 */
if (!customElements.get('ob-compare')) {
  customElements.define(
    'ob-compare',
    class ObCompare extends HTMLElement {
      connectedCallback() {
        this.range = this.querySelector('.ob-compare__range');
        if (!this.range) return;
        this.onInput = () => this.set(this.range.value);
        this.onDown = (e) => {
          if (e.button !== undefined && e.button !== 0) return;
          // Mouse: stop the browser from starting a native image drag or a text selection.
          if (e.pointerType === 'mouse') e.preventDefault();
          this.dragging = true;
          this.startX = e.clientX;
          this.startY = e.clientY;
          this.decided = e.pointerType === 'mouse';
          if (this.decided) this.moveTo(e.clientX);
        };
        this.onMove = (e) => {
          if (!this.dragging) return;
          if (!this.decided) {
            const dx = Math.abs(e.clientX - this.startX);
            const dy = Math.abs(e.clientY - this.startY);
            if (dx < 6 && dy < 6) return;
            // Mostly vertical: let the page scroll and stop tracking.
            if (dy > dx) { this.dragging = false; return; }
            this.decided = true;
            try { this.setPointerCapture(e.pointerId); } catch (err) {}
          }
          this.moveTo(e.clientX);
        };
        this.onUp = (e) => {
          // A tap (no drag) jumps the split to the tap position.
          if (this.dragging && !this.decided) this.moveTo(e.clientX);
          this.dragging = false;
        };
        this.range.addEventListener('input', this.onInput);
        this.addEventListener('pointerdown', this.onDown);
        this.addEventListener('pointermove', this.onMove);
        this.addEventListener('pointerup', this.onUp);
        this.addEventListener('pointercancel', () => { this.dragging = false; });
        this.addEventListener('dragstart', (e) => e.preventDefault());
        // Keep tracking a mouse drag even when the cursor leaves the image.
        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') { try { this.setPointerCapture(e.pointerId); } catch (err) {} }
        });
      }
      disconnectedCallback() {
        if (this.range) this.range.removeEventListener('input', this.onInput);
      }
      moveTo(clientX) {
        const rect = this.getBoundingClientRect();
        if (!rect.width) return;
        const pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
        this.range.value = Math.round(pct);
        this.set(pct);
      }
      set(value) {
        this.style.setProperty('--split', value + '%');
      }
    }
  );
}
